var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('custom-modal',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('balance.title'))+" ")]},proxy:true}]),model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('CheckBalance',{on:{"close-modal":_vm.close}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }